<ng-container *ngIf="filterItems && filterItems.length > 0">
  <!--Section Header-->
  <lib-section-header
    [title]="title"
    [titleIcon]="titleIcon"
    [titleIconUrl]="titleIconUrl"
    [colorScheme]="subsectionColorScheme">
  </lib-section-header>
  <section *ngIf="filterItems && filterItems.length > 0" class="section {{colorScheme.main}}">
    <!--Team/League Picker-->
    <lib-picker-slider
      class="picker-slider {{layout}}"
      [items]="filterItems"
      [style.display]="filterItems.length < 2 ? 'none' : ''"
      [colorScheme]="subsectionColorScheme"
      (onSelect)="onItemSelect($event)">
    </lib-picker-slider>

    <div class="spinner-container" *ngIf="loading">
      <mat-spinner strokeWidth="2" color="{{colorScheme.accent}}" diameter="54" class="m-auto"></mat-spinner>
    </div>

    <!-- OVERVIEW LAYOUT -->
    <div class="overview-subsection subsection" #overviewSection
         *ngIf="layout == FilterSectionLayout.Overview && !loading">
      <lib-news-section
        *ngIf="news.length > 0"
        [newsList]="news"
        [colorScheme]="subsectionColorScheme"
        [layout]="mixedLayout">
      </lib-news-section>
      <div class="overview-data" *ngIf="upcomingEvents && pastEvents">
        <div class="overview-matches">
          <lib-match-section
            *ngIf="upcomingEvents.length > 0"
            [matches]="upcomingEvents"
            [layout]="MatchSectionLayout.Minimal"
            [colorScheme]="subsectionColorScheme"
          ></lib-match-section>
          <lib-match-section
            *ngIf="pastEvents.length > 0"
            [matches]="pastEvents"
            [layout]="MatchSectionLayout.Minimal"
            [colorScheme]="subsectionColorScheme"
          ></lib-match-section>
        </div>
        <lib-league-table
          *ngIf="leagueForTable"
          [league]="leagueForTable"
          [showSeasonSelect]="false"
          [smallTable]="true"
          [singleTable]="true"
          [showTabs]="false"
          [highlightTeamId]="tableTeamId"
          [rowLimit]="4"
          [colorScheme]="subsectionColorScheme"
        ></lib-league-table>
      </div>
      <!--Other News-->
      <lib-news-section
        *ngIf="otherNews.length > 0"
        title="Im Fokus"
        titleIcon="whatshot"
        [titleSize]="smallTitleSize"
        [newsList]="otherNews"
        [colorScheme]="subsectionColorScheme"
        [layout]="rowLayout">
      </lib-news-section>
      <!--More Button-->
      <lib-more-button
        *ngIf="moreButtonLink"
        [title]="moreButtonTitle"
        [link]="moreButtonLink"
        [colorScheme]="subsectionColorScheme">
      </lib-more-button>
    </div>

    <!-- VIDEO LAYOUT -->
    <div class="videos-subsection subsection" #videosSection
         *ngIf="layout == FilterSectionLayout.Video && !loading">
      <!--Livestreams-->
      <lib-match-section
        *ngIf="live.length > 0"
        class="video-section"
        title="Livestreams"
        titleIcon="play_circle"
        [titleSize]="smallTitleSize"
        [matches]="live"
        [colorScheme]="subsectionColorScheme">
      </lib-match-section>
      <!--News-->
      <lib-news-section
        *ngIf="news.length > 0"
        class="video-section"
        title="Im Fokus"
        titleIcon="whatshot"
        [titleSize]="smallTitleSize"
        [newsList]="news"
        [colorScheme]="subsectionColorScheme"
        [layout]="rowLayout">
      </lib-news-section>
      <!--Highlights-->
      <lib-match-section
        *ngIf="highlights.length > 0"
        class="video-section"
        title="Highlights"
        titleIcon="star"
        [titleSize]="smallTitleSize"
        [matches]="highlights"
        [colorScheme]="subsectionColorScheme">
      </lib-match-section>
      <!--Replays-->
      <lib-match-section
        *ngIf="replays.length > 0"
        class="video-section"
        title="Replays"
        titleIcon="replay"
        [titleSize]="smallTitleSize"
        [matches]="replays"
        [colorScheme]="subsectionColorScheme">
      </lib-match-section>
      <!--More Button-->
      <lib-more-button
        *ngIf="moreButtonLink"
        [title]="moreButtonTitle"
        [link]="moreButtonLink"
        [colorScheme]="subsectionColorScheme">
      </lib-more-button>
    </div>

    <!-- NEWS LAYOUT -->
    <div class="subsection" #newsSection
         *ngIf="layout == FilterSectionLayout.News && !loading">
      <lib-news-section
        *ngIf="news.length > 0"
        [newsList]="news"
        [colorScheme]="subsectionColorScheme"
        [layout]="mixedLayout">
      </lib-news-section>
      <lib-news-section
        *ngIf="otherNews.length > 0"
        [newsList]="otherNews"
        [colorScheme]="subsectionColorScheme"
        [layout]="rowLayout">
      </lib-news-section>
      <!--More Button-->
      <lib-more-button
        *ngIf="moreButtonLink"
        [title]="moreButtonTitle"
        [link]="moreButtonLink"
        [colorScheme]="subsectionColorScheme">
      </lib-more-button>
    </div>
  </section>
</ng-container>
